
if(ID.mainSlider) {
    window.mainSlider = new Swiper('#mainSlider', {
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        on: {
            init: () => {
                setTimeout(() => {
                    const el = document.querySelector('#thumbSlider .swiper-slide:first-child');
                    if (el) {
                        el.classList.add('active');
                        if(el.nextElementSibling) {
                            mainSlider.navigation.nextEl.classList.remove("swiper-button-disabled");
                            mainSlider.navigation.prevEl.classList.remove("swiper-button-disabled");
                        }
                    }
                }, 100)
            }
        }
    })
}

if(ID.thumbSlider) {
    window.thumbSlider = new Swiper('#thumbSlider', {
        direction: 'vertical',
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        spaceBetween: 5,
        slidesPerView: 4,
        breakpoints: {
            991: { // lg
                slidesPerView: 3,
            },
            1199: { // xl
                slidesPerView: 4
            }
        }
    });

    document.addEventListener("DOMContentLoaded", () => {

        let prevButton = ID.thumbSlider.querySelector('.swiper-button-prev')
        if(prevButton) prevButton.classList.remove('swiper-button-disabled');

        App.resize(() => {
          let i;
          if (App.mdDown()) {
            thumbSlider.changeDirection('horizontal');
            (i=document.querySelector('#thumbSlider .swiper-button-prev')) && i.classList.remove('vertical');
            (i=document.querySelector('#thumbSlider .swiper-button-next')) && i.classList.remove('vertical');
            (i=document.querySelector('#thumbSlider .swiper-button-prev i')) && (i.innerText = 'keyboard_arrow_left');
            (i=document.querySelector('#thumbSlider .swiper-button-next i')) && (i.innerText = 'keyboard_arrow_right');
          } else {
            thumbSlider.changeDirection('vertical');
            (i=document.querySelector('#thumbSlider .swiper-button-prev')) && i.classList.add('vertical');
            (i=document.querySelector('#thumbSlider .swiper-button-next')) && i.classList.add('vertical');
            (i=document.querySelector('#thumbSlider .swiper-button-prev i')) && (i.innerText = 'keyboard_arrow_up');
            (i=document.querySelector('#thumbSlider .swiper-button-next i')) && (i.innerText = 'keyboard_arrow_down');
          }

        })()

    });

    // Hide navigation when thumb items less than 5
    let i;
    if (i=document.querySelectorAll('#thumbSlider .swiper-slide')) if(i.length < 5) {
        for (const el of document.querySelectorAll('#thumbSlider .swiper-button-next, #thumbSlider .swiper-button-prev')) {
            el.remove()
        }
    }

}

if(ID.mainSlider && ID.thumbSlider) {

    // Update thumb slider active
    mainSlider.on('slideChange', function () {
        thumbSlider.slideTo(mainSlider.activeIndex)
        for (const el of document.querySelectorAll('#thumbSlider .swiper-slide')) {
            el.classList.remove('active')
        }
        let i;
        (i=document.querySelector(`#thumbSlider .swiper-slide:nth-child(${mainSlider.activeIndex + 1})`)) && i.classList.add('active')
    })

    // Update main slider active
    for (const el of document.querySelectorAll('#thumbSlider .swiper-slide')) {
        el.addEventListener('click', () => {
            mainSlider.slideTo(Array.prototype.indexOf.call(el.parentElement.children, el))
        })
    }
}

// Photoswipe
const openPhotoSwipe = (items, activeIndex) => {
    activeIndex = typeof activeIndex !== 'undefined' ? activeIndex : 0
    const pswpElement = document.querySelector('.pswp')
    const options = {
        index: activeIndex
    }

    const gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options)
    gallery.init()
}

let items = []
for (const el of document.querySelectorAll('.swiper-gallery-carousel img')) {
    // Collect items
    items.push({
        src: el.getAttribute('data-large'),
        w: el.getAttribute('data-width'),
        h: el.getAttribute('data-height')
    })

    // Open on click
    el.addEventListener('click', () => {
        openPhotoSwipe(items, Array.prototype.indexOf.call(el.parentElement.children, el))
    })
}
